import apiAsync from '../axios'
import { InterFaceUrl_SEC} from '../config'
import paramsWrap from '../params/params-wrap'
// import langUtils from '@/lang/utils'
export default{
  /**
   * @returns result<Object>
   * depositStatus:      入金状态， 1 已入金； 0 未入金
   * openAccountStatus:    开户状态，1 已开户； 0 未开户
   * tradeAccount:     交易账号
   * tradeStatus:      交易状态 1 已交易； 0 未交易
   * transferStatus:    转仓状态，1 已转仓； 0 未转仓
   * userRegStatus:     开户状态，1 已注册； 0 未注册
   * withdrawalStatus:   出金状态， 1 已出金； 0 未出金
   * */
   findCrmllserStatus: params => apiAsync({
    method: 'post',
    url: InterFaceUrl_SEC('/open_api/findCrmUserStatus'),
    data: paramsWrap.COMMON(params),
    loading: true,
    catchs: true,
    toast: true
  }), 
}